import { Button } from '@warp-ds/react/components/button';
import { Modal } from '@warp-ds/react/components/modal';
import { Select } from '@warp-ds/react/components/select';
import { Toggle, type ToggleEntry } from '@warp-ds/react/components/toggle';
import { type ChangeEvent, useState } from 'react';

export type SortingProps = {
    sortOptions: ToggleEntry[];
    defaultSort: string;
    selectedSort: string | undefined;
    onChange: (value?: string) => void;
};

export const Sorting = ({ sortOptions, defaultSort, selectedSort, onChange }: SortingProps) => {
    const [sortModalOpen, setSortModalOpen] = useState(false);

    const currentSort: string = selectedSort ?? defaultSort;
    const selectedSortToggle: ToggleEntry | undefined = sortOptions.find((opt) => opt.value === currentSort);

    const onSortDropdownChange = (event: ChangeEvent<HTMLSelectElement>): void => {
        onChange(event.target.value === defaultSort ? undefined : event.target.value);
    };

    const onSortToggleChange = (entry: ToggleEntry): void => {
        onChange(entry.value === defaultSort ? undefined : (entry.value as string));
        setSortModalOpen(false);
    };

    return (
        <div>
            <Button
                utility
                small
                onClick={() => setSortModalOpen(true)}
                className="flex items-center gap-8 md:hidden whitespace-nowrap"
                data-testid="sortButton"
                aria-haspopup="dialog"
                aria-expanded={sortModalOpen}>
                <w-icon name="Sorting" size="small" aria-hidden />
                {selectedSortToggle?.label}
            </Button>
            <Select
                className="hidden md:block"
                aria-label="Sorter på"
                value={currentSort}
                onChange={onSortDropdownChange}
                data-testid="sortDropdown">
                {sortOptions.map((option) => (
                    <option key={option.value as string} value={option.value as string}>
                        {option.label}
                    </option>
                ))}
            </Select>
            <Modal open={sortModalOpen} onDismiss={() => setSortModalOpen(false)} title="Sorter etter" right>
                <Toggle
                    type="radio"
                    options={sortOptions}
                    selected={selectedSortToggle ? [selectedSortToggle] : []}
                    onChange={onSortToggleChange}
                    className="flex flex-col gap-8"
                />
            </Modal>
        </div>
    );
};
